import React, { useState } from "react";
import { Layout, Menu, Button, message } from "antd";

import "./layout.css";
import { Routes, Route, useNavigate, Navigate, useLocation } from "react-router-dom";
import {
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
  CarOutlined,
  FlagOutlined,
  ShopOutlined,
  DeploymentUnitOutlined,
  SplitCellsOutlined,
  BgColorsOutlined,
  ThunderboltOutlined,
  FireOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { accessToken, refreshToken, userData } from "../redux/userDataSlice";
import { routes } from "../api/routes";
import { callApi } from "../api/apiCaller";
import Users from "../pages/userlist/Users";
import TermsConditions from "../pages/termsConditions/termsConditions";
import PrivacyPolicy from "../pages/privacyPolicy/privacyPolicy";
import VehicleMakes from "../pages/vehicleMakes/vehicleMakes";
import VehicleModels from "../pages/vehicleModels/vehicleModels";
import VehicleVariants from "../pages/vehicleVariants/vehicleVariants";
import Colours from "../pages/colours/colours";
import Transmissions from "../pages/transmissions/transmissions";
import FuelTypes from "../pages/fuelTypes/fuelTypes";
import Vehicles from "../pages/vehicles/vehicles";
import Reports from "../pages/reports/reports";
import { termsConIcon, privacyIcon } from "../assets";
import Loader from "../components/loader/loader";

const { Header, Sider, Content } = Layout;
const LayoutDashboard = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [loggingOut, setLoggingOut] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const clearSessionAndRedirect = () => {
    dispatch(userData(null));
    dispatch(accessToken(""));
    dispatch(refreshToken(""));
    navigate("/login", { replace: true });
  };

  const logOut = () => {
    const body = {
      device: {
        id: "3242fwefwe4324",
      },
    };

    const onSuccess = (res) => {
      if (res.status === 200) {
        clearSessionAndRedirect();
      } else {
        message.warning("Logout API respond with unexpected status, clearing session locally.");
        clearSessionAndRedirect();
      }
    };

    const onError = (error) => {
      const errorMsg = error?.message || error?.response?.data?.message || "Failed to logout from server, clearing session locally.";
      message.error(errorMsg);
      clearSessionAndRedirect();
    };

    callApi("POST", routes.logOut, body, setLoggingOut, onSuccess, onError);
  };

  const getSelectedKey = () => {
    const path = location.pathname;

    if (path === "/" || path.startsWith("/customers")) return "1";
    if (path.startsWith("/vehicles")) return "2";
    if (path.startsWith("/reports")) return "3";
    if (path.startsWith("/vehicle-makes")) return "4";
    if (path.startsWith("/vehicle-models")) return "5";
    if (path.startsWith("/vehicle-variants")) return "6";
    if (path.startsWith("/colours")) return "7";
    if (path.startsWith("/transmissions")) return "8";
    if (path.startsWith("/fuel-types")) return "9";
    if (path.startsWith("/privacy-policy")) return "10";
    if (path.startsWith("/terms-conditions")) return "11";

    return "";
  };
  return (
    <Layout className="admin-layout">
      <Loader loading={loggingOut} />
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width="15%"
        className="admin-sider"
        theme="light"
        breakpoint="lg"
      >
        <div style={{ height: 32, margin: 16, textAlign: "center" }}>
          <span style={{ color: "#555BDF", fontSize: 18, fontWeight: "bold" }}>
            {collapsed ? "MT" : "MotoSwipe"}
          </span>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[getSelectedKey()]}
          items={[
            {
              key: "1",
              icon: <UserOutlined />,
              label: "Customers",
              onClick: () => navigate("/customers"),
            },
            {
              key: "2",
              icon: <CarOutlined />,
              label: "Vehicles",
              onClick: () => navigate("/vehicles"),
            },
            {
              key: "3",
              icon: <FlagOutlined />,
              label: "Reports",
              onClick: () => navigate("/reports"),
            },
            {
              key: "4",
              icon: <ShopOutlined />,
              label: "Vehicle makes",
              onClick: () => navigate("/vehicle-makes"),
            },
            {
              key: "5",
              icon: <DeploymentUnitOutlined />,
              label: "Vehicle models",
              onClick: () => navigate("/vehicle-models"),
            },
            {
              key: "6",
              icon: <SplitCellsOutlined />,
              label: "Variants",
              onClick: () => navigate("/vehicle-variants"),
            },
            {
              key: "7",
              icon: <BgColorsOutlined />,
              label: "Colours",
              onClick: () => navigate("/colours"),
            },
            {
              key: "8",
              icon: <ThunderboltOutlined />,
              label: "Transmissions",
              onClick: () => navigate("/transmissions"),
            },
            {
              key: "9",
              icon: <FireOutlined />,
              label: "Fuel types",
              onClick: () => navigate("/fuel-types"),
            },
            {
              key: "10",
              icon: (
                <img
                  src={privacyIcon}
                  alt="privacy"
                  style={{ width: 16, marginTop: 2 }}
                />
              ),
              label: "Privacy Policy",
              onClick: () => navigate("/privacy-policy"),
            },
            {
              key: "11",
              icon: (
                <img
                  src={termsConIcon}
                  alt="terms"
                  style={{ width: 16, marginTop: 2 }}
                />
              ),
              label: "Terms Conditions",
              onClick: () => navigate("/terms-conditions"),
            },
            {
              key: "12",
              icon: <LogoutOutlined />,
              label: "Logout",
              onClick: () => logOut(),
            },
          ]}
        />
      </Sider>

      <Layout>
        <Header className="admin-header">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
              marginRight: 16,
            }}
          />
          <h1 className="header-title">MotoSwipe Admin Panel</h1>
        </Header>

        <Content className="admin-content">
          <Routes>
            <Route path="/" element={<Navigate to="/customers" replace />}></Route>
            <Route path="/customers" element={<Users />}></Route>
            <Route path="/vehicles" element={<Vehicles />}></Route>
            <Route path="/reports" element={<Reports />}></Route>
            <Route path="/vehicle-makes" element={<VehicleMakes />}></Route>
            <Route path="/vehicle-models" element={<VehicleModels />}></Route>
            <Route path="/vehicle-variants" element={<VehicleVariants />}></Route>
            <Route path="/colours" element={<Colours />}></Route>
            <Route path="/transmissions" element={<Transmissions />}></Route>
            <Route path="/fuel-types" element={<FuelTypes />}></Route>
            <Route path="/terms-conditions" element={<TermsConditions />}></Route>
            <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutDashboard;
